/** Attribute the experience runtime writes a block's Scroll point name to. */
export const SCROLL_POINT_ATTRIBUTE = 'data-hen-scroll-point';

/**
 * Finds the block by its Scroll point name. Values are compared rather than
 * interpolated into a selector, so any author-typed name is safe.
 */
export function findScrollPoint(
  name: string,
  doc: Document = document,
): Element | null {
  const blocks = doc.querySelectorAll(`[${SCROLL_POINT_ATTRIBUTE}]`);
  for (const block of Array.from(blocks)) {
    if (block.getAttribute(SCROLL_POINT_ATTRIBUTE) === name) return block;
  }
  return null;
}

/**
 * `display: contents` hosts have no box. Walk to the first child that does
 * so IntersectionObserver can see the block the author named. Styles are
 * read through the element's own window because the block may live in an
 * iframe, where the parent window's `getComputedStyle` and element classes
 * don't apply.
 */
export function resolveObserveTarget(block: Element): Element {
  const view = block.ownerDocument.defaultView;
  if (!view) return block;
  let current = block;
  for (let depth = 0; depth < 6; depth += 1) {
    if (view.getComputedStyle(current).display !== 'contents') return current;
    const child = current.firstElementChild;
    if (!child) return current;
    current = child;
  }
  return current;
}
